/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export interface IHotspot extends ITopologyElement, INetworkElement, IGeoPositionable {
        href: string;
        name: string;
        ssid: string;
        owner: string;
        duration: string;
        creationDate: Date;
        getDisplayLabel: () => string;
        canWrite?: boolean;
    }

    export class Hotspot implements IHotspot {
        public href: string;
        public name: string;
        public ssid: string;
        public geoElement: Models.IGeoElement;
        public owner: string;
        public duration: string;
        public creationDate: Date;
        public x: number;
        public y: number;
        public networkInterfaces: INetworkInterface[];
        public physicalLocation: string;
        public defaultGatewayId: number;
        public canWrite: boolean;

        public static Empty(): Hotspot {
            return new Hotspot();
        }

        public static Copy(hotspot: Hotspot): Hotspot {
            let newHotspot: Hotspot = new Hotspot();
            newHotspot.href = hotspot.href;
            newHotspot.name = hotspot.name;
            newHotspot.ssid = hotspot.ssid;
            newHotspot.geoElement = hotspot.geoElement;
            newHotspot.owner = hotspot.owner;
            newHotspot.duration = hotspot.duration;
            newHotspot.creationDate = hotspot.creationDate;
            newHotspot.x = hotspot.x;
            newHotspot.y = hotspot.y;
            newHotspot.networkInterfaces = hotspot.networkInterfaces;
            newHotspot.physicalLocation = hotspot.physicalLocation;
            newHotspot.defaultGatewayId = hotspot.defaultGatewayId;
            return newHotspot;
        }

        constructor() {
            // empty constructor
            this.href = '';
            this.name = '';
            this.ssid = '';
            this.geoElement = new Models.GeoElement();
            this.geoElement.auto = true;
            this.owner = '';
            this.duration = 'Permanent';
            this.creationDate = new Date();
            this.x = undefined;
            this.y = undefined;
            this.networkInterfaces = [];
            this.physicalLocation = '';
            this.canWrite = false;
            
        }

        public class(): TopologyElementType {
            return TopologyElementType.Hotspot;
        }

        public getDisplayLabel(): string {
            return this.name;
        }

        public getDisplayImage(): string {
            return 'images/iconmonstr-radio-tower-8-240.png';
        }
        
        public getAvailableInterfaces(): INetworkInterface[] {
            return this.networkInterfaces.filter (
                (nic: INetworkInterface) => {
                    /* tslint:disable */return nic.networkConnectedTo === null;/* tslint:enable */
                }
            );
        }

         public isConnectedToNetwork(): boolean {
            return this.networkInterfaces.some (
                (nic: INetworkInterface) => {
                    /* tslint:disable */
                    return nic !== undefined &&
                        nic.networkConnectedTo !== undefined && nic.networkConnectedTo !== null;
                    /* tslint:enable */
                }
            );
        }
    }
}
